<template>
  <div id="account">
    <the-top-bar title="Account" />
    <div class="content">
      <div class="profile-icon">
        <i class="material-icons-outlined">
          account_circle
        </i>
      </div>
      <div class="card">
        <div class="card-content">
          <ul>
            <li class="tab waves-effect" v-for="(item, index) in tabs" :key="index" @click="$_goTo(item.route)">
              <span class="material-icons-outlined grey-text text-darken-3 tab-icon">{{ item.icon }}</span>
              <span class="tab-text">{{ item.text }}</span>
              <i class="material-icons-outlined grey-text text-darken-3 arrow">keyboard_arrow_right</i>
            </li>
            <!-- <li class="tab waves-effect" @click="$_logout()">
            <i class="material-icons-outlined grey-text text-darken-3 tab-icon"
              >exit_to_app</i
            >
            <span class="tab-text">Signout</span>
          </li> -->
          </ul>
        </div>
      </div>

    </div>
    <app-bottom-tab />
  </div>
</template>
<script>
import AppBottomTab from "@/components/AppBottomTab/AppBottomTab.vue";
import TheTopBar from "@/components/TheTopBar.vue";
import { logout } from "@/api/user.api";
export default {
  components: { AppBottomTab, TheTopBar },
  name: "Account",
  props: {},
  data() {
    return {
      tabs: [
        // {
        //   text: "Profile",
        //   route: "Profile",
        //   icon: "person",
        // },
        {
          text: "Home Profile",
          route: "HomeProfile",
          icon: "house",
        },
        // {
        //   text: "Reset Password",
        //   route: "ResetPassword",
        //   icon: "lock",
        // },
      ],
    };
  },
  mounted() { },
  computed: {},
  methods: {
    $_logout() {
      this.$store.commit("User/LOAD_DEFAULT");
      logout().then((x) => {
        this.$router.push({ path: "/login" });
      });
    },
    $_goTo(route) {
      this.$router.push({ name: route });
    },
  },
};
</script>
<style lang="scss" scoped>
#account {
  .tab {
    display: flex;
    align-items: center;
    padding: 16px 0px;

    &::after {
      content: ' ';
      position: absolute;
      left: 0;
      bottom: 0;
      height: 1px;
      background: #f4f4f4;
      width: 100%;
    }

    .tab-icon {
      margin-right: 16px;
    }

    .tab-text {
      font-size: 18px;
    }

    .arrow {
      position: absolute;
      right: 0px;
    }
  }

  .content {
    max-width: 690px;
    padding: 16px;
    margin: auto;

    .card {
      .card-content {
        padding: 0 24px;
      }
    }
  }
}

.profile-icon {
  text-align: center;
  padding-top: 12px;

  &::after {
    content: 'Account Settings';
    text-align: center;
    display: block;
    margin-bottom: 15px;
    font-size: 22px;
    line-height: 1;
  }

  i {
    font-size: 84px;
    color: #252525;
  }
}
</style>
